import { api } from "@services/authService"

export interface ChangePasswordRequest {
	currentPassword: string
	newPassword: string
}

export interface ChangePasswordResponse {
	success: boolean
	message: string
}

export interface UpdateSecurityRequest {
	token?: string
	changedEmail?: string
	setEmailValidated?: boolean
	setEmailAsUsername?: boolean
	changedPhone?: string
	setPhoneValidated?: boolean
	primaryMFA?: string
	secondaryMFA?: string
}

export interface UpdateSecurityResponse {
	success: boolean
	message: string
}

export async function changePassword(
	payload: ChangePasswordRequest
): Promise<ChangePasswordResponse> {
	const { data } = await api.put<{ data: { message: string; result: string } }>(
		"/agents/change-password",
		payload
	)

	return {
		success: data.data.result === "success",
		message: data.data.message
	}
}

export async function updateSecurity(
	payload: UpdateSecurityRequest
): Promise<UpdateSecurityResponse> {
	const { data } = await api.put<{ data: UpdateSecurityResponse }>(
		"/agents/login-security",
		payload
	)

	return data.data
}
